export enum STORES {
  KEYCLOAK = 'KEYCLOAK'
}

export const store = (key: string, value: unknown) => {
  localStorage.setItem(
    key,
    typeof value === 'object' ? JSON.stringify(value) : String(value)
  )
}

export const read = <T>(key: string): T | undefined => {
  const _value = localStorage.getItem(key)

  if (_value) {
    try {
      return JSON.parse(_value)
    } catch (e) {
      console.error(e)
      return undefined
    }
  }
}

export const remove = (key: string) => {
  localStorage.removeItem(key)
}
